exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".video-not-available-container{width:100%;height:486px}.video-not-available-container--mobile{width:100%;margin-top:64px}", ""]);
